export enum UserRole {
  MAKLER = "Makler",
  MAKLERBETREUER = "Maklerbetreuer",
  PRODUKTGEBER = "Produktgeber",
  KEINE = "Keine",
}
